import { useQuery } from '@tanstack/react-query'
import { Input, Modal, SpinnerWithBackground, Table, type TableColumn, Text, TextArea } from '@viapeople/components'
import { useNavigate, useParams } from 'react-router-dom'
import { trpc } from '../../../../utils/trpc'
import type { CycleEmailHistory } from '../types'

const recipientsColumns: TableColumn<CycleEmailHistory['recipients'][number]>[] = [
	{
		field: 'firstName',
		label: 'Name',
		render: (item) => `${item.firstName} ${item.lastName}`,
	},
	{
		field: 'email',
		label: 'Email',
	},
]

const exclusionsColumns: TableColumn<CycleEmailHistory['exclusions'][number]>[] = [
	{
		field: 'firstName',
		label: 'Name',
		render: (item) => `${item.firstName} ${item.lastName}`,
	},
	{
		field: 'email',
		label: 'Email',
	},
]

const EmailHistory = ({ history }: { history: CycleEmailHistory }) => {
	return (
		<div className='p-6'>
			<Text variant='h6' weight='semibold' className='mb-6'>
				Email log
			</Text>

			<Input label='Subject' defaultValue={history.emailTemplate.subject} disabled className='mb-4' />
			<TextArea label='Body' defaultValue={history.emailTemplate.body} disabled rows={12} />

			<Text variant='medium' weight='semibold' className='mb-4 mt-6'>
				Recipients
			</Text>

			<Table columns={recipientsColumns} data={history.recipients} className='w-full' noBorder />

			<Text variant='medium' weight='semibold' className='my-4'>
				Exclusions
			</Text>

			<Table columns={exclusionsColumns} data={history.exclusions} className='w-full' noBorder />
		</div>
	)
}

export const CycleEmailHistoryLogTab: React.FC = () => {
	const { cycleId, organizationId, historyId } = useParams<{
		cycleId: string
		organizationId: string
		historyId: string
	}>()
	const navigate = useNavigate()

	const { data: history } = useQuery(
		trpc.admin.cycles.emails.history.show.queryOptions({
			historyId: historyId as string,
		}),
	)

	if (!cycleId || !organizationId || !historyId) {
		return null
	}

	return (
		<Modal
			isOpen
			onClose={() => navigate(-1)}
			fullContent
			fullScreen
			title={!history ? 'Loading...' : history.emailTemplate.name}
			bodyClassName='overflow-y-auto max-h-[90vh]'>
			{!history && <SpinnerWithBackground />}
			{!!history && <EmailHistory history={history} />}
		</Modal>
	)
}
